import React from 'react';

export default function JobModal({ job, onClose }) {
  if (!job) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h5>Job Details</h5>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <h4 style={{ color: '#2a4d8f', marginBottom: 8 }}>{job.job_title}</h4>
          <p style={{ color: '#777', marginBottom: 16 }}>
            <i className="bi bi-geo-alt"></i> {job.job_location || 'N/A'} &nbsp;|&nbsp;
            <i className="bi bi-people"></i> {job.total_positions || 'N/A'} positions
          </p>
          {job.job_categories && <p><strong>Category:</strong> {job.job_categories}</p>}
          {job.skills_required && (
            <div style={{ marginBottom: 16 }}>
              <h6 style={{ fontWeight: 600 }}><i className="bi bi-tools"></i> Required Skills</h6>
              <p>{job.skills_required}</p>
            </div>
          )}
          <div>
            <h6 style={{ fontWeight: 600 }}><i className="bi bi-file-text"></i> Job Description</h6>
            <div
              style={{ background: '#f8f9fa', padding: 12, borderRadius: 6, fontSize: 14 }}
              dangerouslySetInnerHTML={{ __html: job.job_description || '<p>No description available</p>' }}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary btn-sm" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
